export function setPageMeta(title: string, description: string) {
  document.title = `${title} | Ayro Technologies`;

  const meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');

  if (meta) {
    meta.content = description;
  }
}
